<template>
  <div class="home">

    <br>
    <v-container>
      <div class="text-center">
      <h1>ÜGYVITELI INFORMATIKAI MEGOLDÁSOK</h1>
      <br>
      <p class="title">Biztosítjuk vállalkozása informatikai hátterét, legyen szó számítógép beszerzésről, szoftverfejlesztésről, vagy éppen csak tanácsadásról!</p>
      </div>
      <br>
      <v-row justify="center" class="text-center">
        <v-col cols="12" md="4">
          <v-card
            min-height="360"
          >
          <center>
            <v-img
              class="pt-8"
              src="../assets/coding.png"
              width="150px"
              contain
            ></v-img>
          </center>
            <v-card-title class="justify-center">
              EGYEDI <br>
              SZOFTVERFEJLESZTÉS
            </v-card-title>

            <v-card-text>
              Nem kell beérnie félmegoldásokkal!<br>Nyilvántartó rendszerét, webalkalmazását igényei szerint alakítjuk ki.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            min-height="360"
          >
          <center>
            <v-img
              class="pt-8"
              src="../assets/desktop-computer.png"
              width="150px"
              contain
            ></v-img>
          </center>

            <v-card-title class="justify-center">
              ESZKÖZBESZERZÉS
            </v-card-title>

            <v-card-text>
              Igény szerint segítünk a megfelelő számítógép-park költséghatékony beszerzésében.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            min-height="360"
          >
          <center>
            <v-img
              class="pt-8"
              src="../assets/consultation.png"
              width="150px"
              contain
            ></v-img>
          </center>

            <v-card-title class="justify-center">
              TANÁCSADÁS
            </v-card-title>

            <v-card-text>
              Még nincsenek konkrét elképzelései cége informatikai hátterével kapcsolatban? Segítünk megtalálni az ideális megoldásokat!
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-8 text-center">
        <v-col cols="12">
          <v-btn
            outlined
            color="red"
            @click="goToDemo()"
          >
            Próbálja ki Demo Alkalmazásunkat!
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-8">
      <v-col cols="12" md="8">
        <v-card
          outlined
          shaped
          color="orange lighten-5"
        >
          <v-list-item>
            <v-list-item-content>
              <h1 class="headline mb-1 font-weight-bold">
                Miért az egyedi fejlesztés?
              </h1>
            </v-list-item-content>
            <v-icon
              x-large
              color="orange darken-2"
            >
              lightbulb
            </v-icon>
          </v-list-item>

          <v-card-subtitle class="title black--text">
            Rugalmasság:
          </v-card-subtitle>
          <v-card-text class="text-justify">
            A piacon rengeteg úgynevezett "dobozos" szoftvert lehet találni, amik megoldást jelenthetnek egy-egy adott problémára, de ezek többsége nem egészíthető ki saját igényekkel, így megkötik az Ön kezét is cége működési folyamatainak irányításában!
          </v-card-text>

          <v-card-subtitle class="title black--text">
            Egyszerű bővíthetőség:
          </v-card-subtitle>
          <v-card-text class="text-justify">
            Amennyiben később további funkciókra lenne szüksége a már meglévő alkalmazáshoz, az egyszerűen és költséghatékonyan beépíthető, nem kell újabb és újabb szoftvereket vásárolnia és széttöredeznie az egyes munkafolyamatokat! Egységesen, egy programból érhet el mindent, amire szüksége van!
          </v-card-text>

        </v-card>
      </v-col>
      </v-row>

      <v-row justify="center" class="mt-8">
        <v-col cols="12" md="8">
          <v-card
            outlined
            shaped
            color="indigo lighten-5"
          >
            <v-list-item>
              <v-list-item-content>
                <h1 class="headline mb-1 font-weight-bold">
                  Milyen előnyei vannak egy modern ügyfél-nyilvántartó rendszernek?
                </h1>
              </v-list-item-content>
              <v-icon
                x-large
                color="orange darken-2"
              >
                dashboard
              </v-icon>
            </v-list-item>

            <v-card-subtitle class="title">
              Néhány fontosabb funkció:
            </v-card-subtitle>
            <v-container>
            <v-card-text>
            <v-expansion-panels multiple v-model="panel" flat>
              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <b>Mobil munkavégzés</b>
                  <template v-slot:actions>
                    <v-icon color="primary">
                      devices
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Rendszerét eléri mobil eszközökről is, így nincs helyhez kötve a munkavégzés!
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <b>Hatékony kapcsolattartás</b>
                  <template v-slot:actions>
                    <v-icon color="teal">
                      question_answer
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Automatizált rendszerüzenetek, értesítések munkatársai és ügyfelei részére (akár sms formában is)!
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <b>Rendszerintegráció</b>
                  <template v-slot:actions>
                    <v-icon color="error">
                      account_tree
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Legyen szó hatósági adatszolgáltatásról vagy egyéb külső programról, mi biztosítjuk az adatátadást!
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header disable-icon-rotate>
                  <b>Automatizált számlázás</b>
                  <template v-slot:actions>
                    <v-icon color="orange">
                      receipt_long
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Rendszerét össze tudjuk kapcsolni online számlázójával!
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
            </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-8">
      <v-col cols="12" md="4">
      <v-alert
        icon="done_outline"
        prominent
        text
        type="success"
      >
      Bízza feladatait ügyviteli rendszerére!
      </v-alert>
      </v-col>
      <v-col cols="12" md="4">
      <v-alert
        icon="grid_off"
        prominent
        text
        type="error"
      >
      Felejtse el a fölösleges Excel táblákat!
      </v-alert>
      </v-col>
      </v-row>

      <v-snackbar
        v-model="snackbar"
        timeout="8000"
        color="rgba(0,0,0,0.8)"
        max-width="1700px"
      >
        <p class="hidden-sm-and-down mt-3">Tájékoztatjuk, hogy a felhasználói élmény fokozásának érdekében sütiket alkalmazunk. Honlapunk használatával ön a tájékoztatásunkat tudomásul veszi.</p>
        <p class="hidden-md-and-up">Az oldal sütiket alkalmaz! Honlapunk használatával ön a tájékoztatásunkat tudomásul veszi.</p>
        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Rendben!
          </v-btn>
        </template>
      </v-snackbar>

    </v-container>

    <v-btn
      right
      bottom
      fab
      fixed
      color="red lighten-1"
      @click="goToContact()"
    >
      <v-icon
      color="white"
      >
        email
      </v-icon>
    </v-btn>

  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  },
  data: () => ({
    panel: [0, 1, 2, 3],
    snackbar: true,
  }),
  methods: {
    goToDemo: async function() {
      await window.scrollTo(0,0);
      this.$router.push({path: '/demo'});
    },
    goToContact: async function() {
      await window.scrollTo(0,0);
      this.$router.push({path: '/kapcsolat'});
    },
  },
  watch: {

  }
}
</script>
